export default __webpack_public_path__ + "static/media/0xacd7b3d9c10e97d0efa418903c0c7669e702e4c0.5dfc7738.webp";